import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=0b2e5d98&scoped=true&"
import script from "./Disclaimer.vue?vue&type=script&lang=ts&"
export * from "./Disclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=0b2e5d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e5d98",
  null
  
)

export default component.exports